/**
 * 统一时间筛选：yyyy-MM-dd HH:mm:ss，默认当天 00:00:00 ~ 23:59:59
 */

function pad2(n) {
  return String(n).padStart(2, '0')
}

export function formatDateTime(date) {
  return [
    date.getFullYear(),
    pad2(date.getMonth() + 1),
    pad2(date.getDate())
  ].join('-') + ` ${pad2(date.getHours())}:${pad2(date.getMinutes())}:${pad2(date.getSeconds())}`
}

function dayBounds(baseDate) {
  const start = new Date(baseDate.getFullYear(), baseDate.getMonth(), baseDate.getDate(), 0, 0, 0)
  const end = new Date(baseDate.getFullYear(), baseDate.getMonth(), baseDate.getDate(), 23, 59, 59)
  return [formatDateTime(start), formatDateTime(end)]
}

/** @returns {[string, string]} 今日 00:00:00 ~ 23:59:59 */
export function getTodayRange() {
  return dayBounds(new Date())
}

/** @returns {[string, string]} 昨日 00:00:00 ~ 23:59:59 */
export function getYesterdayRange() {
  const d = new Date()
  d.setDate(d.getDate() - 1)
  return dayBounds(d)
}

/** @returns {[string, string]} 近七日（含今日）：今日往前 6 天 00:00:00 ~ 今日 23:59:59 */
export function getLast7DaysRange() {
  const end = new Date()
  const start = new Date(end.getFullYear(), end.getMonth(), end.getDate() - 6, 0, 0, 0)
  const endOfToday = new Date(end.getFullYear(), end.getMonth(), end.getDate(), 23, 59, 59)
  return [formatDateTime(start), formatDateTime(endOfToday)]
}

/** @returns {[string, string]} [开始时间, 结束时间] */
export function getDefaultDateRange() {
  return getTodayRange()
}

export function rangesEqual(a, b) {
  if (!a || !b || a.length < 2 || b.length < 2) return false
  return a[0] === b[0] && a[1] === b[1]
}

/** @returns {'today'|'yesterday'|'last7'|''} */
export function matchDateRangePreset(range) {
  if (!range || range.length < 2) return ''
  if (rangesEqual(range, getTodayRange())) return 'today'
  if (rangesEqual(range, getYesterdayRange())) return 'yesterday'
  if (rangesEqual(range, getLast7DaysRange())) return 'last7'
  return ''
}

export const DATE_RANGE_PRESETS = [
  { key: 'today', label: '今日', getRange: getTodayRange },
  { key: 'yesterday', label: '昨日', getRange: getYesterdayRange },
  { key: 'last7', label: '近七日', getRange: getLast7DaysRange }
]

export const DATE_TIME_FORMAT = 'yyyy-MM-dd HH:mm:ss'
export const DEFAULT_TIME = ['00:00:00', '23:59:59']
